<template>
  <section class="display-detail">
    <p slot="title">
      <span>{{ billMonth }}</span
      >月陈列数据
      <span class="display-status">{{ status }}</span>
    </p>
    <descriptions
      title="基本信息"
      :data="basicInfo"
      v-if="basicInfo.length != 0"
    ></descriptions>
    <descriptions
      title="陈列信息"
      :data="displayInfo"
      v-if="displayInfo.length != 0"
    ></descriptions>
    <Tabs value="operationLog">
      <TabPane label="操作日志" name="operationLog">
        <Table border :columns="columns" :data="dataSource" ref="table"></Table>
      </TabPane>
    </Tabs>
  </section>
</template>

<script>
import descriptions from "@/views/shopTask/components/descriptions";
import * as CONSTANTS from "./validate/constants";

const initFormValidate = {
  receivePerson: "",
  receiveMobile: "",
  address: "",
  addr: "",
  valid: "0"
};
const infoKeys = ["basicInfo", "displayInfo"];
const BOOLEAN_TEXT = {
  true: "是",
  false: "否"
};

export default {
  name: "display-detail",
  components: {
    descriptions
  },
  data() {
    return {
      status: "",
      billMonth: "",
      visiable: false,
      details: {},
      dataSource: [],
      basicInfo: [],
      displayInfo: [],
      columns: [
        {
          title: "时间",
          key: "updatetime"
        },
        {
          title: "操作人",
          key: "operatorName"
        },
        {
          title: "备注",
          key: "ext"
        }
      ]
    };
  },
  created() {
    this.getDisplayQueryDetail();
  },
  methods: {
    async getDisplayQueryDetail() {
      const { id } = this.$route.query;
      const params = {
        id: id
      };
      const { data } = await this.$api["displayQueryDetail"](params);
      this.details = data;
      this.status = this.switchStatus(data.status) || "";
      this.dataSource = data.optLogList || [];
      this.billMonth = data.billMonth ? data.billMonth.replace("-", "年") : "";

      if (data.detailViewList.length > 0) {
        const viewList = data.detailViewList[0];
        this.details.detailViewList = viewList.number;
        this.details.imageList = viewList.imageList ? viewList.imageList : "";
      }

      const infos = infoKeys.reduce(
        (prev, curr) => ({
          ...prev,
          [curr]: this.formDetails(curr, CONSTANTS[curr])
        }),
        {}
      );
      this.basicInfo = infos.basicInfo || [];
      this.displayInfo = infos.displayInfo || [];
    },
    switchStatus(status) {
      switch (status) {
        case "1":
          return "待审核";
        case "20":
          return "审核通过";
        case "10":
          return "审核拒绝";
        case "-255":
          return "已作废";
        default:
          return "";
      }
    },
    formDetails(type, labels) {
      const { details } = this;
      const actionTypes = {
        common: values =>
          Object.entries(values).reduce(
            (prev, [key, label], rowKey) =>
              details[key] == undefined
                ? prev
                : [
                    ...prev,
                    {
                      label,
                      values: ![true, false].includes(details[key])
                        ? details[key]
                        : BOOLEAN_TEXT[details[key]] || null,
                      rowKey,
                      type: this.selectPhotoType(key)
                    }
                  ],
            []
          )
      };
      return actionTypes.common(labels);
    },
    selectPhotoType(v) {
      return v == "imageList" ? "photo" : "";
    }
  }
};
</script>

<style scoped>
.display-detail {
  padding: 0 20px;
}

.display-status {
  margin-left: 5px;
  height: 19px;
  background: #fce5e6;
  line-height: 1;
  border-radius: 4px;
  display: inline-block;
  padding: 0 4px;
  line-height: 19px;
  font-weight: 600;
  font-size: 12px;
  color: #e7212b;
}
</style>



// WEBPACK FOOTER //
// src/views/shopTask/shopDisplayDetail.vue